var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notFound"}},[_c('div',{staticClass:"notFound"},[_c('p',[_vm._v("😵")]),_c('p',[_vm._v("Page Not Found")]),_c('p',[_vm._v("404")])])])
}]

export { render, staticRenderFns }